import {
  BULK_PROCESS_SUCCESS,
  CHECK_PRE_VERIFICATION_SUCCESS,
  CLEAR_PRE_VERIFICATION_STATE_DATA,
  CLEAR_PRE_VERIFICATION_STATE_SUCCESS,
  CREATE_PRE_VERIFICATION_SUCCESS,
  FETCH_ASSET_MODELS_SUCCESS,
  FETCH_ASSET_SUB_TYPE_SUCCESS,
  FETCH_PRE_VERIFICATION_SUCCESS,
  GET_PRE_VERIFICATION_COMBINE_REPORT_SUCCESS,
  GET_PRE_VERIFICATION_SUCCESS, GET_PV_BY_VOUCHER_SUCCESS,
  PRE_VERIFICATION_UPLOAD_COUNT_DECREASE,
  PRE_VERIFICATION_UPLOAD_COUNT_INCREASE, PV_QR_RESET_PROCESS_SUCCESS,
  SAVE_PRE_VERIFICATION_QUERY,
  SAVE_PRE_VERIFICATION_STATE_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetSubTypes: [],
  assetModels: [],
  initialRecord: {},
  astUploadCount: 1,
  warning: {},
  combineReportData: [],
  pvQrResetJob: null,
  pvRecordByVoucher: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_PRE_VERIFICATION_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_PRE_VERIFICATION_SUCCESS: {
      const query = {...state.query};
      if (query && query.pagination) {
        query.pagination.total = action.count || 0;
      }
      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_PRE_VERIFICATION_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case CHECK_PRE_VERIFICATION_SUCCESS: {
      return {
        ...state,
        warning: action.data,
      }
    }

    case FETCH_PRE_VERIFICATION_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case CLEAR_PRE_VERIFICATION_STATE_SUCCESS: {
      return {
        ...state,
        resource: {},
      }
    }

    case FETCH_ASSET_SUB_TYPE_SUCCESS: {
      return {
        ...state,
        assetSubTypes: action.data,
      }
    }

    case FETCH_ASSET_MODELS_SUCCESS: {
      return {
        ...state,
        assetModels: action.data,
      }
    }


    case CLEAR_PRE_VERIFICATION_STATE_DATA: {
      return {
        ...state,
        resource: {},
        record: {},
        edit: {},
        astUploadCount: 1
      }
    }

    case SAVE_PRE_VERIFICATION_STATE_SUCCESS: {
      return {
        ...state,
        record: action.data,
      }
    }

    case PRE_VERIFICATION_UPLOAD_COUNT_INCREASE: {
      return {...state, astUploadCount: state.astUploadCount + 1};
    }

    case PRE_VERIFICATION_UPLOAD_COUNT_DECREASE: {
      return {...state, astUploadCount: state.astUploadCount - 1};
    }

    case GET_PRE_VERIFICATION_COMBINE_REPORT_SUCCESS: {
      return {
        ...state,
        combineReportData: action.data
      };
    }

    case PV_QR_RESET_PROCESS_SUCCESS: {
      return {
        ...state,
        pvQrResetJob: action.data,
      }
    }

    case GET_PV_BY_VOUCHER_SUCCESS: {
      return {
        ...state,
        pvRecordByVoucher: action.data,
      }
    }

    default:
      return state;
  }
}
